import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import history from './history';
import store from './store'
import './index.css';
import App from './App';
import { setAxiosAccessToken } from './services/helpers';

setAxiosAccessToken();

// createRoot batches the store updates from one game update into one render, so what changed is seen as one move.
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    {/* The app's one history: sagas navigate with it and hear the page change (leaving a game closes its channels). */}
    <HistoryRouter history={history}>
      <App />
    </HistoryRouter>
  </Provider>
);
